import { IComponentController } from 'angular';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IMenuItemSelectionClass } from '../../../../../core/services/menu/menu-item-selection.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';


interface IPageAc0039 extends IComponentController {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
}
/* @ngInject */
export default function Ac0039Controller(
    Formulaire: IFormulaireClass,
    Menu: IMenuClass,
    ac0010Route: IRoute,
    ac2008Route: IRoute,
    MenuItemSelection: IMenuItemSelectionClass,
    MenuItemEcran: IMenuItemEcranClass,
    FormulaireItem: IFormulaireItemClass
) {
    const vm: IPageAc0039 = this;
    vm.$onInit = $onInit;
    function $onInit() {
        vm.multiOccurrenceOptions = {
            criteresSuggeres: new Formulaire(
                [
                    new FormulaireItem('refcleint'),
                    new FormulaireItem('usrcle'),
                    new FormulaireItem('datdeb', { largeur: 10 }),
                    new FormulaireItem('datfin', { largeur: 10 })
                ], { largeurDefaut: 33 }
            ),
            navigatePage: ac0010Route.NAME,
            navigateParams: (rowData: any) => ({
                id: rowData.doccleint
            }),
            fonctions: {
                criteresSuggeresVisibles: true,
                criteresRechercheCollapsable: false,
                criteresRechercheOpened: true,
                reinitialiserOuvrirCriteres: true,
                rechercheCollapsable: false,
                effaceCriteres: true
            },
            actionsSelection: new Menu([
                new MenuItemSelection(
                    'LBL_BTN_EPUR',
                    'BOUEPR',
                    {
                        selection: {
                            nom: 'selection',
                            lblConfirmationTitre: 'LBL_BTN_EPUR',
                            confirmationFormulaire: new Formulaire([
                                new FormulaireItem('datfin'),
                                new FormulaireItem('usrcleintsource', {required: true, default: () => getSelectedUsrcleint()}),
                                new FormulaireItem('doccleintref', {required: true, default: () => getSelectedDoccleintref()}),
                                new FormulaireItem('daicleint', {required: true, default: () => getSelectedDaicleint()})
                            ])
                        },
                        fonction: 'BOUEPR',
                        successAction: () => {
                            vm.multiOccurrence.fetchDataList();
                        }
                    }),
                new MenuItemSelection(
                    'LBL_BTN_TRANSF',
                    'BOUTRASF',
                    {
                        selection: {
                            nom: 'selection',
                            lblConfirmationTitre: 'LBL_BTN_TRANSF',
                            confirmationFormulaire: new Formulaire([
                                new FormulaireItem('usrsource', {readonly: true, default: () => getSelectedUsrsource()}),
                                new FormulaireItem('usrcleintsource', {required: true, default: () => getSelectedUsrcleint()}),
                                new FormulaireItem('doccleintref', {required: true, default: () => getSelectedDoccleintref()}),
                                new FormulaireItem('usrcleintdst')
                            ])
                        },
                        fonction: 'BOUTRASF',
                        successAction: () => {
                            vm.multiOccurrence.fetchDataList();
                        }
                    }),
                new MenuItemSelection(
                    'LBL_BTN_COPIER',
                    'BOUCOUP',
                    {
                        selection: {
                            nom: 'selection',
                            lblConfirmationTitre: 'LBL_BTN_COPIER',
                            confirmationFormulaire: new Formulaire([
                                new FormulaireItem('usrsource', {readonly: true, default: () => getSelectedUsrsource()}),
                                new FormulaireItem('usrcleintsource', {required: true, default: () => getSelectedUsrcleint()}),
                                new FormulaireItem('doccleintref', {required: true, default: () => getSelectedDoccleintref()}),
                                new FormulaireItem('usrcleintdst')
                            ])
                        },
                        fonction: 'BOUCOUP',
                        successAction: () => {
                            vm.multiOccurrence.fetchDataList();
                        }
                    })

            ]),
            colonnesVisibles: [
                { nom: 'dacnumdoc', largeur: 180 },
                { nom: 'dacnumdocseq', largeur: 80 },
                { nom: 'sysboncmd', largeur: 150 },
                { nom: 'tydcod', largeur: 70 },
                { nom: 'uhcdat', largeur: 120 },
                { nom: 'peccod', largeur: 100 },
                { nom: 'usrcod', largeur: 100 },
                { nom: 'refcod', largeur: 120 },
                { nom: 'refnom', largeur: 180 },
                { nom: 'etcnumdoc', largeur: 180 },
                { nom: 'etcnumdocseq', largeur: 150 },
                { nom: 'caadsc', largeur: 200 },
                { nom: 'intcodreq', largeur: 120 },
                { nom: 'intnomreq', largeur: 180 },
                { nom: 'intcodach', largeur: 100 },
                { nom: 'intnomach', largeur: 180 },
                {
                    nom: 'vecdaccat', largeur: 180, menu: [
                        new MenuItemEcran(
                            'LBL_CONSULT_ITEM',
                            ac2008Route.NAME,
                            (rowData: any) => ({
                                id: rowData.uhccleint,
                                uhccleint: rowData.uhccleint,
                                doccleint: rowData.doccleint
                            }),
                            {
                                icon: 'launch',
                                iconButton: true,
                                fonction: 'BOUUHC',
                                directionTooltip: 'top'
                            }
                        )
                    ]
                }
            ],
            colonnesCachees: ['doccleint', 'uhccleint', 'usrcleintsrc', 'usrsource', 'daicleint']
        };
    }

    function getSelectedUsrsource() {
        const elementSelectionnes = vm.multiOccurrence.getSelectedRows();
        const selectedRowsUsrsource = elementSelectionnes.map(row => row.usrsource);
        return (selectedRowsUsrsource);
    }

    function getSelectedUsrcleint() {
        const elementSelectionnes = vm.multiOccurrence.getSelectedRows();
        const selectedRowsUsrcleint = elementSelectionnes.map(row => row.usrcleintsrc);
        return (selectedRowsUsrcleint);
    }

    function getSelectedDoccleintref() {
        const elementSelectionnes = vm.multiOccurrence.getSelectedRows();
        const selectedRowsDoccleintref = elementSelectionnes.map(row => row.doccleint);
        return (selectedRowsDoccleintref);
    }

    function getSelectedDaicleint() {
        const elementSelectionnes = vm.multiOccurrence.getSelectedRows();
        const selectedRowsDaicleint = elementSelectionnes.map(row => row.daicleint);
        return (selectedRowsDaicleint);
    }
}
